/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RefreshButton/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import RefreshIcon from 'DesignSystem/Svgs/RefreshIcon/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'



/** @type {import('Simple/types.js').View} */
export default function RefreshButton({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/RefreshButton"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 size="small"
 type="ghost"
 title="Refresh"
 onClick={onClick}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<RefreshIcon
{...childProps}
  viewPath={`${viewPath}/RefreshIcon`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}